import * as React from 'react'

import moment from 'moment'
import type { Moment } from 'moment'

import { BaseEventModel } from 'app/models/baseEventModel'
import { PartialBreakModel } from 'app/models/partialBreakModel'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import { PRINT_BAR_OUTLINE } from '../printStyles'
import { useRestLanes } from '../context/LanesContext'
import { BOTTOM_PADDING } from '../utils/layout'

const color = '#00C2D1'

export type PartialBreakBlockProps = {
  partialBreakModel: PartialBreakModel
  index: number
}

const prepareTooltipInfo = (
  startTime: Moment,
  endTime: Moment,
): BaseEventModel => {
  const info: BaseEventModel = {
    startTime: startTime,
    endTime: endTime,
    typeName: 'eventName.partialBreak',
    color: color,
  }
  return info
}

export const PartialBreakBlock: React.FC<PartialBreakBlockProps> = React.memo(
  (props: PartialBreakBlockProps) => {
    const scene = useScene()
    const { printMode } = useConfig()
    const { restLaneFor, restIsTop } = useRestLanes()

    const renderBreak = (firstPart: boolean) => {
      const HEIGHT = scene.height - 54
      const partialBreakModel = props.partialBreakModel

      let startTime: Moment
      let endTime: Moment

      if (partialBreakModel.startTime && partialBreakModel.endTime) {
        startTime = moment(partialBreakModel.startTime)
        endTime = moment(partialBreakModel.endTime)
      } else {
        startTime = moment(
          firstPart
            ? partialBreakModel.startTime
            : partialBreakModel.secondPartBreakStartTime,
        )
        endTime = moment(
          firstPart
            ? partialBreakModel.firstPartRestEndTime
            : partialBreakModel.formalRestEndDate,
        )
      }

      const itemWidth = scene.widthOf(startTime, endTime)
      const position = scene.timeToX(startTime)
      const lane = restLaneFor(startTime, endTime)
      const isTop = restIsTop(startTime, endTime)

      return (
        <div
          className="tw-flex tw-flex-col tw-items-start tw-justify-end"
          style={{
            position: 'absolute',
            left: position,
            top: 0,
            bottom: 0,
               paddingBottom: BOTTOM_PADDING,
          }}
        >
          <div
            style={{
              background: color,
              boxShadow: printMode ? PRINT_BAR_OUTLINE : undefined,
              borderColor: '#000000',
              pointerEvents: 'auto',
              width: itemWidth,
              height: 6,
              marginBottom: lane * 6,
              borderTopLeftRadius: isTop ? 3 : 0,
              borderTopRightRadius: isTop ? 3 : 0,
            }}
            data-tip={JSON.stringify(prepareTooltipInfo(startTime, endTime))}
            data-for="eventTooltip"
          />
        </div>
      )
    }

    return (
      <div>
        {renderBreak(true)}
        {renderBreak(false)}
      </div>
    )
  },
)

PartialBreakBlock.displayName = 'PartialBreakBlock'
